export enum PermissionOptions {
	RESTRICTED = 'RESTRICTED',
	NOTION = 'NOTION',
	DEFAULT = 'DEFAULT',
}
